import Extractor from './extractor.js';

class Review extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;
    
    result.reviews = [];

    if(data.metatags[0]['application-name'] === 'Yelp'){
      data.review = data.review.slice(1);

      this.setNData(result['reviews'], 'author',
        [
          {instance: data, object:'review', property: 'author'},        
        ], null);

      this.setNData(result['reviews'], 'datepublished',
        [
          {instance: data, object:'review', property: 'datepublished'},        
        ], null);

      this.setNData(result['reviews'], 'body',
        [
          {instance: data, object:'review', property: 'description'},        
        ], null);

      this.setNData(result['reviews'], 'rating',
        [
          {instance: data, object:'rating', property: 'ratingvalue'},        
        ], null);
    }

    result['has_data'] = (result['reviews'].length > 0) ? 1 : 0;

    return result;
  }
}

export default (Review);


// WEBPACK FOOTER //
// ./src/search/extractor/review.js